export default __webpack_public_path__ + "static/media/take.a8dc05df.mp3";